<template>
  <v-card density="compact" :class="procents.left > 0 ? 'normal' : 'out-of-time'" :color="procents.left > 0 ? 'transparent' : 'deep-orange'">
    <template v-slot:prepend>
      <v-icon :icon="['fas', getIcon(ticket['ВидСервиса'])]" />
    </template>
    <template v-slot:append v-if="ticket['Приоритет'] && ticket['Приоритет'] === 'Высокий (критичный)'">
      <v-icon :icon="['fas', 'arrow-up-right-dots']" />
    </template>
    <template v-slot:title>
      {{ ticket['Номер'] }}
    </template>
    <template v-slot:text v-if="procents.left > 0">
      <v-progress-linear
          :value="procents.left" max="100"
          height="25"
          :color="getProgressColor()"
      >
        <template v-slot:default>
          <strong>{{ procents.left }}%</strong>
        </template>
      </v-progress-linear>
    </template>
  </v-card>
</template>

<script>
export default {
  name: "C_Reg_Item",
  props: ['ticket'],
  mounted() {
    this.checkStatus()
  },
  data() {
    return {
      procents: {
        left: 0,
        right: 100
      }
    }
  },
  methods: {
    getProgressColor: function () {
      let color = ''
      if (this.procents.left < 15) {
        color = 'deep-orange'
      }
      if (this.procents.left >= 15 && this.procents.left < 30) {
        color = 'amber'
      }
      if (this.procents.left >= 30) {
        color = 'light-green'
      }
      return color
    },
    checkStatus: function () {
      setInterval(() => {
        let ticketDate = new Date(this.ticket['ДатаОбращения'])
        let deadLine = new Date(new Date(ticketDate).setMinutes(ticketDate.getMinutes() + this.$config.GOOD_PERIOD))
        let currentTime = new Date()
        let left = Math.round((deadLine.getTime() - currentTime.getTime()) / (this.$config.GOOD_PERIOD*60*1000) * 100)
        let right = 100-left
        this.procents = {
          left: left,
          right: right
        }
      }, this.$config.BOARD_TIMER * 1000)
    },
    getDiffDates: function (a, b) {
      let dateStart = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), b.getSeconds());
      let dateEnd = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate(), b.getHours(), b.getMinutes(), b.getSeconds());
      return Math.floor((dateEnd - dateStart) / 1000);
    },
    getIcon: function (type) {
      switch (type) {
        case 'Инцидент (аварийное обращение)':
          return 'triangle-exclamation'
        case 'Заявка на дополнительные / прочие работы':
          return 'toolbox'
        case 'Заявка на отчет, инструктаж, помощь':
          return 'chalkboard-user'
        case 'Заявка на СМР / ПНР':
          return 'helmet-safety'
        case 'Заявка на испытание':
          return 'hand-holding-hand'
        case 'Заявка на техническое обслуживание':
          return 'hand-holding-medical'
        default:
          return 'circle-notch'
      }
    }
  }
}
</script>

<style scoped>
.progress-container:before {
  content: attr(data-text);
  position: absolute;
  left: 0;
  right: 0;
  top:0;
  font-size: 10px;
}

.progress-container {
  text-align: center;
  position: relative;
}
.is-success {
  color: black !important;
  font-size: 20px;
  background-color: transparent !important;
}

.out-of-time {
  animation-name: Blink;
  animation-iteration-count: infinite;
  animation-duration: 1000ms;
  animation-timing-function: ease-in-out;
}

@keyframes Blink {
  0% {
    background: inherit !important;
  }
  100% {
    background: #49b3ff !important;
  }
}

</style>